import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import { getRouters2, getFunctionsByMenuName } from '@/api/common'
import _router from '@/router/index'
import store from "@/store"
import { UserModule } from '@/store/modules/user'

interface Router {
    name: string;
    id: number;
    uri: string;
}

// 关于路由的Vuex文件
@Module({
    name: 'router',
    dynamic: true,
    // namespaced: true,
    store,
})
export default class RouterM extends VuexModule {
    public path  = '/message' // 当前一级路由的uri
    public name: string | null = 'CRM消息' // 当前s一级路由的name
    public activeId: number | null = 1 // 当前一级路由的id
    public pathChildrens = [] // 当前一级路由下的二级路由
    public pathChildrenActiveName: string | null = null // 当前选中的二级路由名称
    public pathChildrenActiveId: number | null = null // 当前选中的二级路由id
    public pathChildrenActive: string | null = null // 当前选中的二级路由路径
    public router1List: Router[] = []

    @Mutation
    SET_PATH(uri: string): void {
        this.path = uri
    }
    @Mutation
    SET_PATHCHILDRENS(arr: any): void {
        this.pathChildrens = arr
    }
    @Mutation
    SET_NAME(name: string): void {
        this.name = name
    }
    @Mutation
    SET_ACTIVEID(id: number) {
        this.activeId = id
    }
    @Mutation
    SET_PATH_ACTIVE_CHILDREN(uri: string){
        this.pathChildrenActive = uri
    }
    @Mutation
    SET_PATH_ACTIVE_CHILDREN_ID(id: number){
        this.pathChildrenActiveId = id
    }
    @Mutation
    SET_PATH_ACTIVE_CHILDREN_NAME(name: string){
        this.pathChildrenActiveName = name
    }
    @Mutation
    SET_ROUTERS1_LIST(arr: Router[]) {
        this.router1List = arr
    }

    @Action
    setRouter1(item: Router) {
        this.context.commit('SET_PATH', item.uri)
        this.context.commit('SET_NAME', item.name)
        this.context.commit('SET_ACTIVEID', item.id)
        window.sessionStorage.setItem('Router1', JSON.stringify(item))
        // this.initPathChildrens()
    }

    @Action
    async setRouter2(item: Router) {
        this.context.commit('SET_PATH_ACTIVE_CHILDREN', item.uri)
        this.context.commit('SET_PATH_ACTIVE_CHILDREN_NAME', item.name)
        this.context.commit('SET_PATH_ACTIVE_CHILDREN_ID', item.id)
        // _router.push(this.path + '/' + item.uri)
        window.sessionStorage.setItem('router2', JSON.stringify(item))
        // 获取用户在当前路由下的权限
        // const data1: any = await getFunctionsByMenuName({ name: item.name })
        // UserModule.SET_BUTTONS(data1.functionsList)
    }

    @Action
    async initPathChildrens() {
        // this.context.commit('SET_PATHCHILDRENS', [])
        // const data: any = await getRouters2({ id: this.activeId })
        // this.context.commit('SET_PATHCHILDRENS', data.menuList)
        // if(!window.sessionStorage.getItem('router2')){
        //     this.setRouter2(data.menuList[0])
        // } else {
        //     this.setRouter2(JSON.parse(window.sessionStorage.getItem('router2') as string))
        // }
        // this.setRouter2(data.menuList[0])
        // console.log(_router.currentRoute.fullPath.split('/'));
        // if(_router.currentRoute.fullPath.split('/').length === 2 && _router.currentRoute.fullPath == this.path) {
        //     _router.push(_router.currentRoute.fullPath + '/' + data.menuList[0].uri)
        //     this.setRouter2(data.menuList[0])
        // }
    }

    @Action
    initRouter1() {
        const str: string = window.sessionStorage.getItem("Router1") || ''
        if(str === '') { 
            this.setRouter1({ name: 'CRM消息', id: 1, uri: '/message' })
            return 
        }
        const router: Router= JSON.parse(str)
        this.setRouter1(router)
    }

}

export const RouterModule = getModule(RouterM)

